// extracted by mini-css-extract-plugin
export default {"slider":"jUpu3P_YdwV2nfqScNCT"};